// import React, { useEffect, useRef, useState } from "react";
// import "./HomeSection1.css";
// import axios from "axios";
// import { toast } from "react-toastify";
// import { Link } from "react-router-dom";

// const HomeSection1 = () =>  {
//   const [data, setData] =  useState([]);
//   const titleRef = useRef(null);


//   useEffect(() => {
//   const observer = new IntersectionObserver(
//     (entries) => {
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           entry.target.classList.add("animate-in");
//         }
//       });
//     },
//     { threshold: 0.1 }
//   );

//   if (titleRef.current) {
//     observer.observe(titleRef.current);
//   }

//   return () => observer.disconnect();
// }, []);

//   useEffect(() => {
//   const fetchData = async () => {
//     try {
//       const response = await axios.post(
//         "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_main_subcategory"
//       );

//       const filterdData = response.data.row.filter(item => item.category_id === "2");

//       setData(filterdData || []);

//       console.log("API Response Sub Category:", response.data);

//       if (response.data.success === "1") {
//         toast.success(response.data.message || "Data fetched successfully!");
//       } else {
//         toast.error(response.data.error || "Failed to fetch data.");
//       }
//     } catch (error) {
//       console.error(error);
//       toast.error("Failed to fetch data.");
//     }
//   };

//   fetchData();
// }, []);

//   return (
//     <div className="shop-section">
//       <h2 className="shop-title" ref={titleRef}>Shop by Category</h2>

//       <div className="shop-grid">
//         {data.map((item, index) => (
//   <div
//     className="shop-card"
//     key={index}
//     // ref={(el) => (cardRefs.current[index] = el)}
//     // style={{ "--delay": `${index * 60}ms` }}
//   >
//     <img
//       src={`https://cyberathon.com/multivendor/${item.image}`}
//       alt={item.subcategory_name}
//       loading="lazy"
//     />

//     <div className="card-overlay">
//       <div className="card-content">
//         <p>{item.subcategory_name}</p>
//         <p>50% OFF</p>
//         <Link
//   to={`/products?category=${item.category_id}&subcategory=${item.subcategory_id}`}
//   className="shop-now"
// >
//          <button className="Addto-cart">
//           Shop Now →
//         </button>
//         </Link>
//       </div>
//     </div>
//   </div>
// ))}
//       </div>
//     </div>
//   );
// };

// export default HomeSection1;











// // 02-11-2026 streekatha
// import React, { useEffect, useRef } from "react";
// import { Link } from "react-router-dom";
// import "./HomeSection1.css";

// const CATEGORY_ID = 2;

// const CARDS = [
 
//   { name: "Banarasi",        slug: "banarasi",        subcategory_id: 1, image: "/img/elegent1.webp" },
//   { name: "Kota Cotton",     slug: "kota-cotton",     subcategory_id: 2, image: "/img/elegent2.webp" },
//   { name: "Mulmul",          slug: "mulmul",          subcategory_id: 3, image: "/img/elegent3.webp" },
//   { name: "Cotton",          slug: "cotton",          subcategory_id: 4, image: "/img/elegent4.webp" },
//   { name: "Maheshwari Silk", slug: "maheshwari-silk", subcategory_id: 5, image: "/img/elegent6.webp" },
//   { name: "Linen",           slug: "linen",           subcategory_id: 6, image: "/img/elegent7.webp" },
//   { name: "Tissue",          slug: "tissue",          subcategory_id: 7, image: "/img/elegent8.webp" },
//   { name: "Dual Shade",      slug: "dual-shade",      subcategory_id: 8, image: "/img/elegent9.webp" },
// ];

// const HomeSection1 = () => {
//   const titleRef = useRef(null);

//   /* Heading scroll par fade-in (pehle jaisa) */
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             entry.target.classList.add("elegantparatha-animate-in");
//           }
//         });
//       },
//       { threshold: 0.1 }
//     );

//     if (titleRef.current) observer.observe(titleRef.current);

//     return () => observer.disconnect();
//   }, []);

//   return (
//     <section className="elegantparatha-section">
//       <h2 className="elegantparatha-title" ref={titleRef}>
//         Elegantly Yours
//       </h2>

//       <div className="elegantparatha-grid">
//         {CARDS.map((card) => (
//           <Link
//             key={card.subcategory_id}
//             // to={`/products?category=${CATEGORY_ID}&subcategory=${card.subcategory_id}`}
//             to={`/elegant-collection/${card.slug}`}
//             className="elegantparatha-card"
//             aria-label={`Shop ${card.name}`}
//           >
//             <img
//               src={card.image}
//               alt={card.name}
//               className="elegantparatha-img"
//               loading="lazy"
//               draggable={false}
//             />
//             <span className="elegantparatha-pill">{card.name}</span>
//           </Link>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default HomeSection1;








// 04-11-2026 dyanamic code
// HomeSection1.jsx
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./HomeSection1.css";

const API_URL =
  "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_z_elegantly_yours";

const HomeSection1 = () => {
  const titleRef = useRef(null);
  const [cards, setCards] = useState([]);

  /* Heading scroll par fade-in (static heading) */
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("elegantparatha-animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    if (titleRef.current) observer.observe(titleRef.current);

    return () => observer.disconnect();
  }, []);

  /* API se cards fetch */
  useEffect(() => {
    const controller = new AbortController();

    const fetchCards = async () => {
      try {
        const res = await fetch(API_URL, { signal: controller.signal });
        const json = await res.json();

        if (json.status === "true" || json.success === "1") {
          /* id ascending: admin ka pehla data pehle card pe.
             Ulta chahiye to Number(b.id) - Number(a.id) kar do */
          setCards(
            (Array.isArray(json.data) ? json.data : [])
              .slice()
              .sort((a, b) => Number(a.id) - Number(b.id))
          );
        } else {
          setCards([]);
        }
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error("Elegantly Yours fetch error:", err);
        }
      }
    };

    fetchCards();
    return () => controller.abort();
  }, []);

  return (
    <section className="elegantparatha-section">
      <h2 className="elegantparatha-title" ref={titleRef}>
        Elegantly Yours
      </h2>

      <div className="elegantparatha-grid">
        {cards.map((card) => (
          <Link
            key={card.id}
            // to={`/elegant-collection/${card.id}`}
                        to={
              card.category_slug
                ? `/${card.category_slug}${
                    Number(card.subcategory_id) > 0
                      ? `?subcategory=${card.subcategory_id}`
                      : ""
                  }`
                : "/all-sarees"
            }
            className="elegantparatha-card"
            aria-label={card.btn_text}
          >
            <img
              src={card.image_url}
              alt={card.btn_text}
              className="elegantparatha-img"
              loading="lazy"
              draggable={false}
            />
            <span className="elegantparatha-pill">{card.btn_text}</span>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default HomeSection1;